var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67478 0.997919C4.47952 0.802657 4.16294 0.802657 3.96767 0.99792L0.785696 4.1799C0.590434 4.37517 0.590434 4.69175 0.785697 4.88701C0.980959 5.08227 1.29754 5.08227 1.4928 4.88701L4.32123 2.05858L7.14966 4.887C7.34492 5.08227 7.6615 5.08227 7.85676 4.887C8.05203 4.69174 8.05203 4.37516 7.85676 4.1799L4.67478 0.997919ZM4.82123 9.68256L4.82123 1.35147L3.82123 1.35147L3.82123 9.68256L4.82123 9.68256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUp);
export default __webpack_public_path__ + "static/media/ico-up.c4061ad6510daddbf2035dc798e52633.svg";
export { ForwardRef as ReactComponent };